module.exports = __webpack_public_path__ + "img/14.954acda6.jpg";